var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scholar"},[_c('div',{staticClass:"scholar__head"},[_vm._v("研究学者")]),_c('ul',{staticClass:"scholar__list"},[_c('li',{staticClass:"list-item"},[_c('div',{staticClass:"label"},[_vm._v("姓名")]),_c('div',[_vm._v("相关发布量")]),_c('div',{staticClass:"num"},[_vm._v("100")])])])])
}]

export { render, staticRenderFns }